import React, {useState} from 'react'
import Title from '../title/Title'
import PopUp from '../popUp/PopUp'
import abrarImage from '../../assets/png/abrar photo.png'
import malakImage from '../../assets/png/malak photo.png'
import memberPhoto from '../../assets/png/member photo.png'
import yazeedImage from '../../assets/png/yazeed photo.png'
import dinaImage from '../../assets/png/dina photo.png'
import addMemberImage from '../../assets/png/add team member.png'
import Input from '../input/Input'



const members= [
{name:'Malak Musa', title:'Co-Founder', img: malakImage},
 {name:'Dina Al-Qawasmeh', title:'Co-Founder', img: dinaImage},
 {name:'Yazeed AlMarwani', title:'Lead Developer', img: yazeedImage},
//  {name:'Abrar Alghamdi', title:'Senior Copywriter', img: abrarImage}

]
export default function TeamMembers() {
    const [addMember, setAddMember] = useState(false)
    const togglePopup = () =>{ 
        setAddMember(!addMember)
    }
    return (
        <div className="landing">
                   <div className="searchHolder">

            
<label className="searchIcon" >


 <input className="searchInput disabled" readOnly = {true} type="text" placeholder="Search" />
</label>
</div>
<Title title="Team Members" subtitle="Habhab's" reversed/>   

<div className="sectionDivider">
            Core Department
            </div>
            <div className="options">
                {members.map(el => <div className="option">
                    <div className={"button "}>
                    <img src={el.img} alt=""/>
                    </div>
                    <p>{el.name}</p>
                    <p style={{color: '#707070', fontSize:'18px', marginTop:'-10px'}} >{el.title}</p>
                    </div>)}
                    <div className="option">
                    <div className={"button "}>
                    <img src={addMemberImage} alt=""/>
                    </div>
                    <button className={"outline"} onClick={togglePopup} style={{width: '100%', marginTop:'20px'}}> Add New Member </button>
                    </div>
            </div>

            <PopUp
            appear={addMember}
            nextPage={togglePopup}
            handleCancel={togglePopup}
            img={memberPhoto}
            title="Hurray! Invite A New Member" 
            text={[]}  
            buttons={[{text:'Save as draft', color:'outlined'}, {text: "Invite", color:"pink"}]}>
                          <Input title="" placeholder="Member’s Name"/>
                          <Input title="" placeholder="Member’s Position"/>
                          <Input title="" placeholder="Member’s Email"/>

            </PopUp>
        </div>
    )
}
